document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('[data-shop-grid]');
  if (!grid) return;

  var productsEl = grid.querySelector('[data-shop-products]');
  var wrappers = Array.prototype.slice.call(grid.querySelectorAll('[data-shop-product-wrapper]'));
  var categorySelect = grid.querySelector('[data-shop-category-select]');

  if (categorySelect) {
    categorySelect.addEventListener('change', function () {
      if (categorySelect.value) window.location.href = categorySelect.value;
    });
  }

  var densityButtons = Array.prototype.slice.call(grid.querySelectorAll('[data-grid-cols]'));

  function setGridCols(cols) {
    if (productsEl) productsEl.style.setProperty('--grid-cols', cols);

    densityButtons.forEach(function (btn) {
      var isActive = btn.dataset.gridCols === cols;
      btn.setAttribute('aria-pressed', String(isActive));
      btn.classList.toggle('bg-ink', isActive);
      btn.classList.toggle('text-cream', isActive);
      btn.classList.toggle('text-brown', !isActive);
    });

    try {
      window.localStorage.setItem('shopGridCols', cols);
    } catch (err) {
      /* localStorage unavailable, ignore */
    }
  }

  densityButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setGridCols(btn.dataset.gridCols);
    });
  });

  var savedCols = null;
  try {
    savedCols = window.localStorage.getItem('shopGridCols');
  } catch (err) {
    /* localStorage unavailable, ignore */
  }
  setGridCols(savedCols || '3');

  var sortWrapper = grid.querySelector('[data-sort-menu]');
  var sortTrigger = grid.querySelector('[data-sort-trigger]');
  var sortPanel = grid.querySelector('[data-sort-panel]');
  var sortOptions = Array.prototype.slice.call(grid.querySelectorAll('[data-sort-option]'));

  function closeSortPanel() {
    if (!sortPanel) return;
    sortPanel.classList.add('hidden');
    if (sortTrigger) sortTrigger.setAttribute('aria-expanded', 'false');
  }

  if (sortTrigger && sortPanel) {
    sortTrigger.addEventListener('click', function (event) {
      event.stopPropagation();
      var isOpen = !sortPanel.classList.contains('hidden');
      sortPanel.classList.toggle('hidden', isOpen);
      sortTrigger.setAttribute('aria-expanded', String(!isOpen));
    });

    document.addEventListener('click', function (event) {
      if (sortWrapper && !sortWrapper.contains(event.target)) closeSortPanel();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSortPanel();
    });
  }

  function applySort(value) {
    if (!productsEl) return;

    var items = wrappers.slice();

    if (value === 'featured') {
      items.sort(function (a, b) {
        return Number(a.dataset.productIndex) - Number(b.dataset.productIndex);
      });
    } else if (value === 'price-asc' || value === 'price-desc') {
      items.sort(function (a, b) {
        var priceA = Number(a.querySelector('[data-product-card]')?.dataset.productPrice) || 0;
        var priceB = Number(b.querySelector('[data-product-card]')?.dataset.productPrice) || 0;
        return value === 'price-asc' ? priceA - priceB : priceB - priceA;
      });
    } else if (value === 'newest') {
      items.sort(function (a, b) {
        var createdA = Number(a.querySelector('[data-product-card]')?.dataset.productCreated) || 0;
        var createdB = Number(b.querySelector('[data-product-card]')?.dataset.productCreated) || 0;
        return createdB - createdA;
      });
    } else if (value === 'alpha-asc') {
      items.sort(function (a, b) {
        var titleA = a.querySelector('[data-product-card]')?.dataset.productTitle || '';
        var titleB = b.querySelector('[data-product-card]')?.dataset.productTitle || '';
        return titleA.localeCompare(titleB);
      });
    }

    items.forEach(function (item) {
      productsEl.appendChild(item);
    });
  }

  sortOptions.forEach(function (option) {
    option.addEventListener('click', function () {
      sortOptions.forEach(function (opt) {
        opt.setAttribute('aria-pressed', String(opt === option));
      });
      applySort(option.dataset.sortOption);
      closeSortPanel();
    });
  });
});
